import enCompanyMeetings from './en';
import ruCompanyMeetings from './ru';

export default {
  en: {
    ...enCompanyMeetings,
  },
  ru: {
    ...ruCompanyMeetings,
  },
};
